import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-guide-o365',
  templateUrl: './guide-o365.component.html',
  styleUrls: ['./guide-o365.component.scss'],
})
export class GuideO365Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
